module.exports = __webpack_public_path__ + "static/media/luggage.fb5876cc.svg";